var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarcodeWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 19,
    viewBox: "0 0 30 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.500183,
    width: 29,
    height: 18,
    rx: 3.5,
    stroke: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 5.00018,
    width: 0.888906,
    height: 8.88906,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11.4443,
    y: 5.00012,
    width: 0.888906,
    height: 8.88906,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 22.1113,
    y: 5.00012,
    width: 0.888906,
    height: 8.88906,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 20.333,
    y: 5.00012,
    width: 0.888906,
    height: 8.88906,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 15.8887,
    y: 5.00012,
    width: 3.55562,
    height: 8.88906,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 13.2217,
    y: 5.00012,
    width: 1.77781,
    height: 8.88906,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 8.77734,
    y: 5.00012,
    width: 1.77781,
    height: 8.88906,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarcodeWhite);
export default __webpack_public_path__ + "static/media/barcode-white.86324e2ef0304eb72d0b4b0743e664a0.svg";
export { ForwardRef as ReactComponent };